import { Routes } from '@angular/router';
import { HomeDashboardComponent } from './components/home-dashboard.component';

export const homeRoutes: Routes = [
  {
    path: 'home',
    component: HomeDashboardComponent,
    data: {
      title: 'Home',
      permissions: ['Bird.Portal:BasicAccess']
    },
    children: []
  }
];



// WEBPACK FOOTER //
// ./src/app/home/routes.config.ts